import { elevatorStarterKit } from './products/elevatorStarterKit.mjs';
import { g2StarterKit } from './products/g2StarterKit.mjs';
import { g2StarterKitPro } from './products/g2StarterKitPro.mjs';
import { g3StarterKit } from './products/g3StarterKit.mjs';
import { g3StarterKitPro } from './products/g3StarterKitPro.mjs';
import { gateAccessStarterKit } from './products/gateAccessStarterKit.mjs';
import './properties/index.mjs';
import { includedAccessories } from './properties/includedAccessories.mjs';
import { includedHub } from './properties/includedHub.mjs';
import { includedReaders } from './properties/includedReaders.mjs';
import { touchPassSupport } from './properties/touchPassSupport.mjs';
"use strict";
const StarterKits = {
  properties: [includedHub, includedReaders, includedAccessories, touchPassSupport],
  products: [g3StarterKitPro, g3StarterKit, g2StarterKitPro, g2StarterKit, elevatorStarterKit, gateAccessStarterKit],
  columnWidth: 339,
  propertyColumnWidth: 167 + 10,
  showBadges: true
};
export { StarterKits };
//# sourceMappingURL=StarterKit.mjs.map
